import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {
  CitizensServicesAutomationDetails,
  filteringInputServicesAutoDetails
} from './citizens-services-automation-details.model';

export const loadCitizensServicesAutomationDetailss = createAction(
  '[CitizensServicesAutomationDetails/API] Load CitizensServicesAutomationDetailss',
  props<{ citizensServicesAutomationDetailss: CitizensServicesAutomationDetails[] }>()
);

export const addCitizensServicesAutomationDetails = createAction(
  '[CitizensServicesAutomationDetails/API] Add CitizensServicesAutomationDetails',
  props<{ citizensServicesAutomationDetails: CitizensServicesAutomationDetails }>()
);

export const upsertCitizensServicesAutomationDetails = createAction(
  '[CitizensServicesAutomationDetails/API] Upsert CitizensServicesAutomationDetails',
  props<{ citizensServicesAutomationDetails: CitizensServicesAutomationDetails }>()
);

export const addCitizensServicesAutomationDetailss = createAction(
  '[CitizensServicesAutomationDetails/API] Add CitizensServicesAutomationDetailss',
  props<{ citizensServicesAutomationDetailss: CitizensServicesAutomationDetails[] }>()
);

export const upsertCitizensServicesAutomationDetailss = createAction(
  '[CitizensServicesAutomationDetails/API] Upsert CitizensServicesAutomationDetailss',
  props<{ citizensServicesAutomationDetailss: CitizensServicesAutomationDetails[] }>()
);

export const updateCitizensServicesAutomationDetails = createAction(
  '[CitizensServicesAutomationDetails/API] Update CitizensServicesAutomationDetails',
  props<{ citizensServicesAutomationDetails: Update<CitizensServicesAutomationDetails> }>()
);

export const updateCitizensServicesAutomationDetailss = createAction(
  '[CitizensServicesAutomationDetails/API] Update CitizensServicesAutomationDetailss',
  props<{ citizensServicesAutomationDetailss: Update<CitizensServicesAutomationDetails>[] }>()
);

export const deleteCitizensServicesAutomationDetails = createAction(
  '[CitizensServicesAutomationDetails/API] Delete CitizensServicesAutomationDetails',
  props<{ id: string }>()
);

export const deleteCitizensServicesAutomationDetailss = createAction(
  '[CitizensServicesAutomationDetails/API] Delete CitizensServicesAutomationDetailss',
  props<{ ids: string[] }>()
);

export const clearCitizensServicesAutomationDetailss = createAction(
  '[CitizensServicesAutomationDetails/API] Clear CitizensServicesAutomationDetailss'
);


//CUSTOM

export const citizenGetServicesAutomationDetails = createAction(
  '[CitizensServicesAutomationDetails/API] citizen Get Services Automation Details',
  props<{ filtering?:filteringInputServicesAutoDetails }>()
);
